import { render } from "./ActiveDangers.vue?vue&type=template&id=46c1b073"
import script from "./ActiveDangers.vue?vue&type=script&lang=js"
export * from "./ActiveDangers.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__